const PSA_SERIAL_PREFIX_TO_CERTIFIER: Readonly<Record<string, string>> = {
  PSACAP: 'PSA Carbon Agro Perene',
  PSACF: 'PSA Carbonflor',
  PSACFLOR: 'PSA Carbonflor',
};

export function resolvePsaCertifierDescription(
  serialCode?: string | null,
  certifierDescription?: string | null
): string {
  if (!serialCode) {
    return certifierDescription ?? '';
  }

  const prefix = serialCode.split('-')[0]?.trim().toUpperCase();
  const certifierFromSerial = prefix ? PSA_SERIAL_PREFIX_TO_CERTIFIER[prefix] : undefined;

  if (certifierFromSerial) {
    return certifierFromSerial;
  }

  return certifierDescription ?? '';
}
